import { LabeledContainer } from '@schibsted-svp/react-ui';
import classNames from 'classnames';

import type { FC, ReactNode } from 'react';

import styles from './FormField.module.scss';

type Props = {
  label: string;
  children?: ReactNode;
  className?: string;
};

const FormField: FC<Props> = ({ label, children, className }) => {
  return (
    <LabeledContainer
      label={label}
      className={classNames(styles.container, className)}
    >
      {children}
    </LabeledContainer>
  );
};

export { FormField };
